module.exports = __webpack_public_path__ + "01ea978f/img/saly-icon.39e12342.jpg";